export default "__VITE_ASSET__c649243e__"